module.exports = __webpack_public_path__ + "assets/img/twokonggou_1.2a5b675d.jpg";